// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2YxX1","inner":"Footer_inner__m6vOE"};